// extracted by mini-css-extract-plugin
export default {"container":"link_container__1HvnC","inner":"link_inner__j2ktD","isContainer":"link_isContainer__2HXyN"};